<template>
  <div class="app">
    <div id="scrollRef">
      <div class="pc-hidden">
        <el-backtop :bottom="100">
          <div class="backtop">
            <i class="el-icon-upload2"></i>
          </div>
        </el-backtop>

        <div>
          <div
            class="homeLogin"
            style="top: 0px">
            <div
              class="homeCont"
              @mouseover="
                (barNum = 0), (clssHei = 0), (shopNavFlg = ''), (tapHeight = 0)
              ">
              <div class="topLoginCont">
                <div @click="toPage(
                    'https://vargoos-cloud.jingshucloud.com/'
                  )">登录</div>
                <p>|</p>
                <div @click="toPage(
                    'https://vargoos-cloud.jingshucloud.com/'
                  )">注册</div>
              </div>
            </div>
          </div>
          <nav class="nav-bar">
            <!-- :style="
          barNum != 0
            ? { padding: 0 + 'px ' + 0 + 'px ' + tapHeight + 'px ' + 0 + 'px ' }
            : ''
        " -->
            <!-- 430 @mouseover="($store.state.enterp_somFlg = '')"-->
            <!-- padding: 40px px 0 360px 12px; :style="clssHei!=0?{ padding: 40 + 'px ' + 0 + 'px ' + 400 + 'px ' + 12 + 'px '}:''"-->
            <div class="barCont">
              <div class="narbarCont">
                <div
                  class="vargo-logo"
                  @click="switchContent('99')"
                  @mouseover="
                    (barNum = 0),
                      (clssHei = 0),
                      (shopNavFlg = ''),
                      (tapHeight = 0)
                  ">
                  <img
                    class="logo-img"
                    src="https://oss.jingshucloud.com/gw-bucket/d9fc08ad-d165-4675-a481-11b03edc1622.png"
                    alt="vargo" />
                  <!-- <div class="line"></div>
        <img
          class="text-img"
          src="@/assets/home-image/京数科技-白.png"
          alt="京数科技"
        /> -->
                </div>
                <div
                  class="nav-list"
                  v-show="!selectInputFlg">
                  <div class="nav-items-list">
                    <!-- <div class="nav-item">
                <div
                  class="nav_top shop"
                  :class="homeFlg ? 'navCol' : ''"
                  @click="switchContent('99')"
                  @mouseover="(barNum = 0), (clssHei = 0)"
                >
                  首页
                  <div :class="homeFlg ? 'botBefore' : ''"></div>
                </div>
              </div> -->

                    <div
                      v-for="(item, index) in $store.state.tapList"
                      :key="index"
                      class="nav-item">
                      <div
                        class="nav_top shop"
                        :class="
                          shopNavFlg == item.idNum || item.navColFlg
                            ? 'navCol'
                            : ''
                        "
                        @click="tapClic(item, index)"
                        @mouseover="tapMous(item.idNum, item.children)">
                        {{ item.name }}
                        <div
                          :class="
                            item.underlineFlag ||
                            ($route.name && $route.name == item.url)
                              ? 'botBefore'
                              : ''
                          "></div>
                      </div>
                      <div
                        class="shoppingNav"
                        v-show="shopNavFlg == item.idNum"
                        ref="shoppingNav"
                        @mouseover.stop="1 == 1">
                        <div
                          class="posReal"
                          v-for="(item1, index1) in item.children"
                          :key="index1"
                          @click="switchMenu">
                          <div
                            style="
                              position: relative;
                              display: table;
                              white-space: nowrap;
                            ">
                            <div
                              class="botWire"
                              @click="tapSubmenuClic(item1, index1, index)"
                              @mouseover.stop="tapSubmenuMous(item1.idNum)"
                              v-if="item1.id != 37 || item1.id != 38">
                              {{ item1.name }}
                              <div
                                :class="
                                  item1.underlineFlag && index !== 1 ? 'botBefore' : ''
                                "></div>
                            </div>
                          </div>
                          <div v-if="item1.children">
                            <div
                              v-for="(item2, index2) in item1.children"
                              :key="index2"
                              @click="
                                childrenClic(item2, index2, index1, index)
                              "
                              v-show="
                                $store.state.enterp_somFlg.indexOf(
                                  item1.idNum
                                ) != -1
                              "
                              class="childrenCont">
                              <div
                                class="enterplink"
                                :class="
                                  $store.state.enterp_somFlg == '5-1' ||
                                  $store.state.enterp_somFlg == '5-2' ||
                                  $store.state.enterp_somFlg == '5-3'
                                    ? 'lefsty'
                                    : ''
                                "></div>
                              <div
                                :class="
                                  item2.underlineFlag
                                    ? $store.state.enterp_somFlg == '5-1' ||
                                      $store.state.enterp_somFlg == '5-2' ||
                                      $store.state.enterp_somFlg == '5-3'
                                      ? index2 > 4
                                        ? 'addopacity lefstyEsc lefstyEscTop'
                                        : 'addopacity lefstyEsc'
                                      : ''
                                    : $store.state.enterp_somFlg == '5-1' ||
                                      $store.state.enterp_somFlg == '5-2' ||
                                      $store.state.enterp_somFlg == '5-3'
                                    ? index2 > 4
                                      ? 'lefstyEsc lefstyEscTop'
                                      : 'lefstyEsc'
                                    : ''
                                "
                                class="enterpSubmenu"
                                :style="{
                                  top: 8 + (index2 % 5) * 80 + 'px',
                                }"></div>

                              <div
                                class="enterpShade"
                                :class="
                                  $store.state.enterp_somFlg == '5-1' ||
                                  $store.state.enterp_somFlg == '5-2' ||
                                  $store.state.enterp_somFlg == '5-3'
                                    ? index2 > 4
                                      ? 'lefstyCot lefstyCotTop'
                                      : 'lefstyCot'
                                    : ''
                                "
                                :style=" $store.state.enterp_somFlg == '5-1' ||
                                  $store.state.enterp_somFlg == '5-2' ||
                                  $store.state.enterp_somFlg == '5-3'?{ top: 18 + (index2 % 5) * 80 + 'px' }:{top: 18 + (index2 % 5) * 80 + 'px'}">
                                <p class="enterpTit">
                                  {{ item2.name }}
                                </p>
                                <!-- <p class="enterpTxt">{{ item2.txt }}</p> -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- <div class="nav-item">
                <div
                  @click="switchContent('2')"
                  @mouseover="mousEntServic('2')"
                  :class="servicFlg ? 'navCol' : ''"
                  class="nav_top shop"
                >
                  企业服务
                  <div :class="servicFlg ? 'botBefore' : ''"></div>
                </div>
                <div class="shoppingNav" v-show="barNum == 2" ref="ServicNav">
                  <div
                    class="posReal"
                    @click="switchContent('2-1')"
                    @mouseover="enterp_som('2-1-1')"
                  >
                    <div
                      class="botWire"
                      :class="submenuSum == '2-1' ? 'W2-1' : ''"
                    >
                      企业安全移动通讯解决方案
                    </div>
                  </div>
                  <div v-show="$store.state.enterp_somFlg == '2-1-1'">
                    <div class="enterpSubmenu"></div>
                    <div class="enterplink"></div>
                    <div class="enterpShade">
                      <p class="enterpTit">公有云服务</p>
                      <p class="enterpTxt">公有服务简单介绍文案内容</p>
                    </div>

                    <div class="enterpSubmenusy"></div>
                    <div class="enterpShadesy">
                      <p class="enterpTit">私有通讯服务</p>
                      <p class="enterpTit">
                        私有通讯服务简单介绍文案内容
                      </p>
                    </div>
                  </div>

                  <div v-show="$store.state.enterp_somFlg == '2-1-7'">
                    <div class="enterplink"></div>
                    <div class="enterpSubmenu"></div>
                    <div class="enterpShade">
                      <p style="height: 7px">安全传输</p>
                      <p style="font-size: 13px">安全传输简单介绍文案内容</p>
                    </div>

                    <div class="enterpSubmenusy"></div>
                    <div class="enterpShadesy">
                      <p style="height: 7px">安全存储</p>
                      <p style="font-size: 13px">安全存储简单介绍文案内容</p>
                    </div>
                    <div class="enterpSubmenusan"></div>
                    <div class="enterpShadesan">
                      <p style="height: 7px">数据隐匿</p>
                      <p style="font-size: 13px">数据隐匿简单介绍文案内容</p>
                    </div>
                  </div>
                  <div v-show="$store.state.enterp_somFlg == '2-1-8'">
                    <div class="enterplink"></div>
                    <div class="enterpSubmenu"></div>
                    <div class="enterpShade">
                      <p style="height: 7px">硬件采购</p>
                      <p style="font-size: 13px">硬件采购简单介绍文案内容</p>
                    </div>

                    <div class="enterpSubmenusy"></div>
                    <div class="enterpShadesy">
                      <p style="height: 7px">软件采购</p>
                      <p style="font-size: 13px">软件采购简单介绍文案内容</p>
                    </div>
                  </div>

                  <div class="posReal" @mouseover="enterp_som('2-1-2')">
                    <div class="botWire">集团通讯解决方案</div>
                  </div>
                  <div class="posReal" @mouseover="enterp_som('2-1-3')">
                    <div class="botWire">企业移动办公安全解决方案</div>
                  </div>
                  <div class="posReal" @mouseover="enterp_som('2-1-4')">
                    <div class="botWire">企业智慧办公解决方案</div>
                  </div>
                  <div class="posReal" @mouseover="enterp_som('2-1-5')">
                    <div class="botWire">企业EMM管理系统</div>
                  </div>
                  <div class="posReal" @mouseover="enterp_som('2-1-6')">
                    <div class="botWire">企业私有化OA系统</div>
                  </div>
                  <div class="posReal" @mouseover="enterp_som('2-1-7')">
                    <div class="botWire">数据安全定制</div>
                  </div>
                  <div class="posReal" @mouseover="enterp_som('2-1-8')">
                    <div class="botWire">企业采购方案</div>
                  </div>
                </div>
              </div> -->

                    <!-- <div class="nav-item">
                <div
                  class="nav_top shop"
                  @mouseover="mousEntServic('3')"
                  @click="switchContent('3')"
                  :class="governFlg ? 'navCol' : ''"
                >
                  政府服务
                  <div :class="governFlg ? 'botBefore' : ''"></div>
                </div>
                <div v-show="barNum == 3" class="shoppingNav" ref="governNav">
                  <div class="posReal">
                    <div class="botWire" @click="switchContent('3-1')">
                      硬件定制服务
                    </div>
                  </div>
                  <div class="posReal">
                    <div class="botWirezxt">系统集成服务</div>
                  </div>
                  <div class="posReal">
                    <div class="botWire" @click="switchContent('3-3')">
                      安全通讯解决方案
                    </div>
                  </div>
                  <div class="posReal">
                    <div class="botWire" @click="switchContent('3-4')">
                      私有通讯解决方案
                    </div>
                  </div>
                  <div class="posReal">
                    <div class="botWire" @click="switchContent('3-5')">
                      政府EMM管理系统
                    </div>
                  </div>
                </div>
              </div> -->

                    <!-- <div class="nav-item">
                <div
                  class="nav_top shop"
                  @click="switchContent('4')"
                  @mouseover="mousEntServic('4')"
                  :class="customizeFlg ? 'navCol' : ''"
                >
                  定制服务
                  <div :class="customizeFlg ? 'botBefore' : ''"></div>
                </div>
                <div v-show="barNum == 4" class="shoppingNav" ref="customize">
                  <div class="posReal">
                    <div class="botWire">硬件定制服务</div>
                  </div>
                  <div class="posReal">
                    <div class="botWire">软件定制服务</div>
                  </div>
                </div>
              </div> -->

                    <!-- <div class="nav-item">
                <div
                  class="nav_top shop"
                  @click="switchContent('5')"
                  @mouseover="mousEntServic('5')"
                  :class="softwareFlg ? 'navCol' : ''"
                >
                  软件产品
                  <div :class="softwareFlg ? 'botBefore' : ''"></div>
                </div>
                <div class="shoppingNav" v-show="barNum == 5" ref="software">
                  <div class="posReal">
                    <div class="botWire">定制化安全软件产品、服务</div>
                  </div>
                  <div class="posReal">
                    <div class="botWire">移动安全解决方案</div>
                  </div>
                  <div class="posReal">
                    <div class="botWire">云平台服务</div>
                  </div>
                </div>
              </div> -->

                    <!-- <div class="nav-item">
                <div
                  class="nav_top shop"
                  @click="switchContent('6')"
                  @mouseover="mousEntServic('6')"
                  :class="serveAllFlg ? 'navCol' : ''"
                >
                  服务
                  <div :class="serveAllFlg ? 'botBefore' : ''"></div>
                </div>
                <div class="shoppingNav" v-show="barNum == 6" ref="serveAll">
                  <div class="posReal">
                    <div class="botWire">售后服务</div>
                  </div>
                  <div class="posReal">
                    <div class="botWire">驱动下载</div>
                  </div>
                </div>
              </div> -->

                    <!-- <div class="nav-item">
                <div
                  class="nav_top shop"
                  :class="aboutUsFlg ? 'navCol' : ''"
                  @mouseover="mousEntServic('7')"
                  @click="switchContent('7')"
                >
                  关于我们
                  <div :class="aboutUsFlg ? 'botBefore' : ''"></div>
                </div>

                <div class="shoppingNav" v-show="barNum == 7" ref="aboutUs">
                  <div class="posReal">
                    <div class="botWire">公司介绍</div>
                  </div>
                  <div class="posReal">
                    <div class="botWire">团队介绍</div>
                  </div>
                  <div class="posReal">
                    <div class="botWire">企业架构介绍</div>
                  </div>
                </div>
              </div> -->

                    <!-- <div class="nav-item" @click="switchContent('8')">
                <div class="nav_top" :class="talentFlg ? 'navCol' : ''">
                  人才计划
                  <div :class="talentFlg ? 'botBefore' : ''"></div>
                </div>
              </div> -->

                    <!-- <div
                class="nav-item"
                @click="switchContent('9')"
                @mouseover="mousEntServic('9')"
              >
                <div class="nav_top shop" :class="awardFlg ? 'navCol' : ''">
                  企业福利
                  <div :class="awardFlg ? 'botBefore' : ''"></div>
                  <div class="shoppingNav" v-show="barNum == 9">
                    <div class="posReal">
                      <div class="botWire">项目奖励</div>
                    </div>
                    <div class="posReal">
                      <div class="botWire">项目奖励</div>
                    </div>
                  </div>
                </div>
              </div> -->
                  </div>
                </div>
                <div
                  class="nav-login"
                  :style="selectInputFlg ? 'width: auto;' : ''">
                  <div
                    @click="goTempDetails"
                    v-show="!selectInputFlg">
                    <img
                      @mouseover="
                        (barNum = 0),
                          (clssHei = 0),
                          (shopNavFlg = ''),
                          (tapHeight = 0)
                      "
                      src="https://oss.jingshucloud.com/gw-bucket/e12db89f-d9b9-4605-ad85-68f84d0b00f4.png"
                      alt="" />
                  </div>
                  <div
                    class="topSelect"
                    v-if="selectInputFlg">
                    <el-input
                      placeholder="请输入关键词"
                      v-model="inputSelectVal"
                      @keyup.enter.native="goSearchIndex()"
                      class="inputSelect">
                      <i
                        slot="suffix"
                        @click.stop="goSearchIndex"
                        class="el-input__icon el-icon-search"></i>
                      <!-- <el-button slot="append"  class="selectBtn"  icon="el-icon-search"></el-button> -->
                      <!-- <div slot="append">
                    搜索
                  </div> -->
                    </el-input>
                    <i
                      style="font-size: 24px; color: #fff; cursor: pointer"
                      @click="selectInputFlg = false"
                      class="el-icon-close"></i>
                  </div>
                  <div
                    @click="inputSeleShow"
                    v-show="!selectInputFlg">
                    <img
                      @mouseover="
                        (barNum = 0),
                          (clssHei = 0),
                          (shopNavFlg = ''),
                          (tapHeight = 0)
                      "
                      src="https://oss.jingshucloud.com/gw-bucket/fcf1afc4-e8f4-4e50-817f-e3df0cf9409e.png"
                      alt="" />
                  </div>
                  <!-- <div class="to-login" @click="tologin">登录</div>
                <div class="line"></div>
                <div class="to-register" @click="tobikeReg">注册</div> -->
                </div>

                <!-- <div
        v-show="barNum != 0 && clssHei != 0"
        class="shadeDiv"
        @mouseover="(barNum = 0), (clssHei = 0)"
      ></div> -->
              </div>
            </div>
          </nav>
          <div
            class="navoPacity"
            :class="barNum !== 0 ? 'bacFilter' : ''"
            :style="{ height: tapHeight + 'px' }"></div>
          <!-- background: linear-gradient(3deg , #003365 0%, #003365 49%, rgb(0 51 101 / 50%) 100%); -->
        </div>
        <!-- 内容遮罩 ,($store.state.enterp_somFlg='')-->
        <!-- && shopNavFlg != 7 && shopNavFlg != 5 -->
        <div
          v-show="shopNavFlg && shopNavFlg != 0"
          @mouseover="
            (shopNavFlg = ''), (barNum = 0), (clssHei = 0), (tapHeight = 0)
          "
          class="shadeCont"></div>
      </div>
      <!-- 内容展示 -->
      <div
        class="overlay"
        ref="overlay"
        @mouseover="
          (shopNavFlg = ''), (barNum = 0), (clssHei = 0), (tapHeight = 0)
        ">
        <router-view
          :key="$route.fullPath"
          v-if="routerAlive"
          :barNum="barNum"
          :inputSeltVal="inputSelectVal"
          @blurSelectVal="blurSelectVal" />
        <!-- <div>
        <div v-if="contFlg == 99 || contFlg == 0">
          <home :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>
        <div v-if="contFlg == '2'">
          <entSerHome :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>
        <div v-if="contFlg == '2-1'">
          <entSer :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>
        <div v-if="contFlg == '3'">
          <goveHome :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>
        <div v-if="contFlg == '3-1'">
          <goveSer :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>
        <div v-if="contFlg == '3-3'">
          <goveCom :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>
        <div v-if="contFlg == '3-4'">
          <govePri :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>
        <div v-if="contFlg == '3-5'">
          <goveEmm :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>
        <div v-if="contFlg == '4'">
          <customize :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>
        <div v-if="contFlg == '5'">
          <systemProduct :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>

        <div v-if="contFlg == '6'">
          <serviceHome :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>

        <div v-if="contFlg == '7'">
          <aboutUs :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>

        <div v-if="contFlg == '8'">
          <talentSch :switchNum.sync="switchNum" @switchflg="switchflg" />
        </div>
      </div> -->
      </div>
      <!-- 底部内容 v-show="contFlg != 4"-->
      <div class="container_bottom pc-hidden">
        <div class="container_bottom_Cont">
          <!-- 服务 -->
          <div class="serve">
            <!-- :class="{ serve_warpper: serveShow }" -->
            <div
              class="serve_warpper"
              ref="serveRef">
              <div class="botLogo">
                <img
                  src="https://oss.jingshucloud.com/gw-bucket/a1c740b7-956c-4d1a-b9e9-f30c613b7664.png"
                  alt="" />
              </div>
              <div class="marleft">
                <div class="serve-item"><div class="botTitle">Vargo云</div></div>
                <div class="serve-item"><a @click="toPage(
                    'https://vargoos-cloud.jingshucloud.com/'
                  )">登录</a></div>
                <div class="serve-item"><a @click="toPage(
                    'https://vargoos-cloud.jingshucloud.com/'
                  )">注册</a></div>
                <!-- <div class="serve-item">
                <a href="#javascript">京数 PAD</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">其他智能设备 </a>
              </div>
              <div class="serve-item"><a href="#javascript">配件</a></div> -->
                <!-- <div class="serve-item"><a href="#javascript">京数 os</a></div>
              <div class="serve-item"><a href="#javascript">京数云</a></div> -->
              </div>
              <div class="marleft">
                <div class="serve-item">
                  <div class="botTitle">销售渠道</div>
                </div>
                <div
                  class="serve-item"
                  v-for="(item, index) in botInfo.distribution_channels"
                  :key="index">
                  <a :href="item.externalUrl">{{ item.name }}</a>
                </div>
                <!-- <div class="serve-item">
                <a href="/serveButHome/onlineHome/tempIndex">官方淘宝</a>
              </div> -->
              </div>
              <!-- <div class="marleft">
              <div class="serve-item"><div class="botTitle">企业服务</div></div>
              <div class="serve-item">
                <a href="#javascript">企业安全移动通讯解决方案</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">集团通讯解决方案</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">企业移动办公安全解决方案</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">企业智慧办公解决方案</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">企业EMM管理系统</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">企业私有化OA系统</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">数据安全定制</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">企业采购方案</a>
              </div>
            </div> -->
              <!-- <div class="marleft">
              <div class="serve-item"><div class="botTitle">政府服务</div></div>
              <div class="serve-item">
                <a href="#javascript">硬件定制服务</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">系统集成服务</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">安全通讯解决方案</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">私有通讯解决方案</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">政府EMM管理系统</a>
              </div>
            </div> -->
              <!-- <div class="marleft">
              <div class="serve-item"><div class="botTitle">软件产品</div></div>
              <div class="serve-item">
                <a href="#javascript">定制化安全软件产品</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">移动安全解决方案</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">云平台服务</a>
              </div>
              <div class="serve-item"><div class="botTitle">定制服务</div></div>
              <div class="serve-item">
                <a href="#javascript">企业定制服务</a>
              </div>
              <div class="serve-item">
                <a href="#javascript">私人定制服务</a>
              </div>
            </div> -->
              <div class="marleft">
                <div class="serve-item">
                  <div class="botTitle">服务支持</div>
                </div>

                <!-- <div class="serve-item">
                <a href="/serviceHome/afterSalesService">售后服务</a>
              </div> -->
                <div
                  class="serve-item"
                  v-for="(item, index) in botInfo.service_supports"
                  :key="index + 'td'">
                  <!-- <a :href="item.routingPath">{{ item.name }}</a> -->
                  <span
                    class="botBtnTxt"
                    @click="goBtnService(item)"
                    >{{ item.name }}</span
                  >
                </div>
                <!-- <div class="serve-item">
                <a href="/serveButHome/serveWarranty">售后查询</a>
              </div>
              <div class="serve-item">
                <a href="/serveButHome/accessoryInquiry">配件查询</a>
              </div>
              <div class="serve-item">
                <a href="/serveButHome/networkQuery">网点查询</a>
              </div>
              <div class="serve-item">
                <a href="/serveButHome/driverDownload">驱动下载</a>
              </div>
              <div class="serve-item">
                <a href="/serveButHome/applicationStore">应用下载</a>
              </div> -->

                <!-- <div class="serve-item">
                  <a href="#javascript">质保服务</a>
                </div>
                <div class="serve-item">
                  <a href="#javascript">在线报修</a>
                </div>
                <div class="serve-item">
                  <a href="#javascript">网点查询</a>
                </div>
                <div class="serve-item">
                  <a href="#javascript">配件查询</a>
                </div>
                <div class="serve-item">
                  <a href="#javascript">售后政策</a>
                </div>
                <div class="serve-item">
                  <a href="#javascript">返修退货处理</a>
                </div>
                <div class="serve-item">
                  <a href="#javascript">产品功能介绍</a>
                </div>
                <div class="serve-item">
                  <a href="#javascript">FAQ</a>
                </div> -->
              </div>
              <div
                class="marleft"
                id="kinds"
                v-if="botInfo.home_contact_us">
                <div class="botTxt">
                  <div class="serve-item">
                    <div class="botTitle">
                      {{ botInfo.home_contact_us[0].title }}
                    </div>
                  </div>
                  <div class="serve-item tellBot">
                    <img
                      style=""
                      src="https://oss.jingshucloud.com/gw-bucket/9b33f833-112c-484f-ab05-b05deafd148d.png"
                      alt="" />
                    <div>{{ botInfo.home_contact_us[0].phone }}</div>
                  </div>
                  <div class="serve-item timeBot">
                    <img
                      src="https://oss.jingshucloud.com/gw-bucket/970d4dd5-57a2-4795-9627-433b68b79fea.png"
                      alt="" />
                    <div>{{ botInfo.home_contact_us[0].businessHours }}</div>
                  </div>
                  <div class="serve-item timeBot">
                    <img
                      src="https://oss.jingshucloud.com/gw-bucket/11be8e8c-ccb9-480a-bbbc-9171b9c4fcf1.png"
                      alt="" />
                    <div>{{ botInfo.home_contact_us[0].eMail }}</div>
                  </div>
                  <div class="serve-item timeBot">
                    <img
                      src="https://oss.jingshucloud.com/gw-bucket/03f42f7e-b9a7-46a1-a5c2-b3d3526d589e.png"
                      alt="" />
                    <div>
                      {{ botInfo.home_contact_us[0].address }}
                    </div>
                  </div>
                </div>
                <!-- <div class="serve-item"><div class="botTitle">联系我们</div></div>
              <div class="serve-item"><a href="#javascript">邮箱</a></div>
              <div class="serve-item"><a href="#javascript">地址</a></div>
              <div class="serve-item">
                <a href="#javascript">电话</a>
              </div> -->
              </div>
              <!-- <div class="marleft">
              <img
                style="display: block; width: 133px; height: 133px"
                src="https://oss.jingshucloud.com/gw-bucket/abe753cd-1c05-4ae2-8c45-de77d6802415.png"
                alt=""
              />
              <div style="text-align: center; margin-top: 19px">微信公众号</div>
            </div> -->

              <!-- <div class="marleft" id="kinds">
              <div class="serve-item"><div class="botTitle">关于我们</div></div>
              <div class="serve-item"><a href="#javascript">公司介绍</a></div>
              <div class="serve-item"><a href="#javascript">团队介绍</a></div>
              <div class="serve-item">
                <a href="#javascript">企业架构介绍</a>
              </div>
            </div> -->
            </div>
          </div>
        </div>
        <!-- 版权号 -->
        <div class="copyright">
          <!-- 泸公网安备 31011502007855号 &nbsp;&nbsp;&nbsp; 泸ICP备14033346号-2
        &nbsp; © &nbsp; 2005-2023 京数科技（上海）有限公司 版权所有 -->
          <!-- 沪ICP备2023025523号-1 -->
          ©&ensp;2005-2024&ensp;京数科技 (上海) 有限公司&nbsp;&nbsp;<a
            class="beian"
            href="https://beian.miit.gov.cn"
            >沪&ensp;ICP&ensp;备&ensp;2023025523&ensp;号-1</a
          >
        </div>
      </div>
    </div>
    <!-- <div id="mobile"></div>
    <router-view /> -->
  </div>
</template>
<script>
import home from '@/components/home.vue';

import entSerHome from '@/components/enterpriseService/enterpriseHome.vue';
import entSer from '@/components/enterpriseService/enterpriseMobileSecurity.vue';
import goveHome from '@/components/governService/goveHome.vue';
import goveSer from '@/components/governService/governmentalService.vue';
import goveCom from '@/components/governService/goveCommunication.vue';
import govePri from '@/components/governService/govePrivateComm.vue';
import goveEmm from '@/components/governService/goveEmm.vue';
import customize from '@/components/customizeService/customizeEnterprise.vue';
import systemProduct from '@/components/systemProduct.vue';
import serviceHome from '@/components/serviceHome.vue';

import aboutUs from '@/components/aboutUs.vue';

import talentSch from '@/components/talentsScheme.vue';
import {
  getInfo,
  getVarGoToken,
  treeselect,
  homeBottom,
  geMenuDetailsInfo,
} from '@/api/index';

import axios from 'axios';
export default {
  name: 'index',
  components: {
    home,
    entSerHome,
    entSer,
    goveHome,
    goveSer,
    goveCom,
    govePri,
    goveEmm,
    customize,
    systemProduct,
    serviceHome,
    aboutUs,
    talentSch,
  },
  mixins: [],
  data() {
    return {
      routerAlive: true,
      selectInputFlg: false,
      // tapList:[],
      inputSelectVal: '',
      tapList: [
        {
          name: '首页',
          underlineFlag: false,
          navColFlg: '',
          idNum: '0',
          url: 'myHome',
        },
        {
          name: '商城',
          underlineFlag: false,
          navColFlg: '',
          idNum: '1',
          url: 'InquiryForm',
          children: [
            {
              name: '安全手机',
              underlineFlag: false,
              navColFlg: '',
              idNum: '1-1',
              url: 'enterpriseHome/enterpriseService',
            },
          ],
        },
        {
          name: '企业服务',
          underlineFlag: false,
          navColFlg: '',
          idNum: '2',
          url: 'enterpriseHome',
          children: [
            {
              name: '企业安全移动通讯解决方案',
              underlineFlag: false,
              navColFlg: '',
              idNum: '2-1',
              url: 'enterpriseHome/enterpriseService',
              children: [
                {
                  tit: '公有云服务',
                  underlineFlag: false,
                  navColFlg: '',
                  idNum: '2-1-1',
                  txt: '内容',
                  url: 'enterpriseHome/enterpriseService/enterprisecublicCloud',
                },
                {
                  tit: '私有云服务',
                  underlineFlag: false,
                  navColFlg: '',
                  idNum: '2-1-2',
                  txt: '测试内容',
                  url: 'enterpriseHome',
                },
              ],
            },
            {
              name: '集团通讯解决方案',
              underlineFlag: false,
              navColFlg: '',
              idNum: '2-2',
              url: 'enterpriseHome',
            },
            {
              name: '企业移动办公安全解决方案',
              underlineFlag: false,
              navColFlg: '',
              idNum: '2-3',
              url: 'enterpriseHome',
            },
            {
              name: '企业智慧办公解决方案',
              underlineFlag: false,
              navColFlg: '',
              idNum: '2-4',
              url: 'enterpriseHome',
            },
            {
              name: '企业EMM管理系统',
              underlineFlag: false,
              navColFlg: '',
              idNum: '2-5',
              url: 'enterpriseHome',
            },
            {
              name: '企业私有化OA系统',
              underlineFlag: false,
              navColFlg: '',
              idNum: '2-6',
              url: 'enterpriseHome',
            },
            {
              name: '数据安全定制',
              underlineFlag: false,
              navColFlg: '',
              idNum: '2-7',
              url: 'enterpriseHome',
              children: [
                {
                  tit: '安全传输',
                  underlineFlag: false,
                  navColFlg: '',
                  idNum: '2-7-1',
                  txt: '内容',
                  url: 'enterpriseHome',
                },
                {
                  tit: '安全存储',
                  underlineFlag: false,
                  navColFlg: '',
                  idNum: '2-7-2',
                  txt: '测试内容',
                  url: 'enterpriseHome',
                },
                {
                  tit: '数据隐匿',
                  underlineFlag: false,
                  navColFlg: '',
                  idNum: '2-7-3',
                  txt: '测试内容',
                  url: 'enterpriseHome',
                },
              ],
            },
            {
              name: '企业采购方案',
              underlineFlag: false,
              navColFlg: '',
              idNum: '2-8',
              url: 'enterpriseHome',
              children: [
                {
                  tit: '硬件采购',
                  underlineFlag: false,
                  navColFlg: '',
                  idNum: '2-8-1',
                  txt: '内容',
                  url: 'enterpriseHome',
                },
                {
                  tit: '软件采购',
                  underlineFlag: false,
                  navColFlg: '',
                  idNum: '2-8-2',
                  txt: '测试内容',
                  url: 'enterpriseHome',
                },
              ],
            },
          ],
        },
        {
          name: '政务服务',
          underlineFlag: false,
          navColFlg: '',
          idNum: '3',
          url: 'goveHome',
          children: [
            {
              name: '硬件定制服务方案',
              underlineFlag: false,
              navColFlg: '',
              idNum: '3-1',
              url: 'goveHome/governmentalService',
            },
            {
              name: '软件定制服务方案',
              underlineFlag: false,
              navColFlg: '',
              idNum: '3-2',
              url: 'goveHome/governmentalService',
            },
            {
              name: '系统集成服务方案',
              underlineFlag: false,
              navColFlg: '',
              idNum: '3-3',
              url: 'goveHome/governmentalService',
            },
            {
              name: '安全通讯解决方案',
              underlineFlag: false,
              navColFlg: '',
              idNum: '3-4',
              url: 'goveHome/governmentalService',
            },
            {
              name: '私有通讯解决方案',
              underlineFlag: false,
              navColFlg: '',
              idNum: '3-5',
              url: 'goveHome/governmentalService',
            },
            {
              name: '政府EMM管理系统',
              underlineFlag: false,
              navColFlg: '',
              idNum: '3-6',
              url: 'goveHome/governmentalService',
            },
          ],
        },
        {
          name: '定制服务',
          underlineFlag: false,
          navColFlg: '',
          idNum: '4',
          url: 'customizeService',
          children: [
            {
              name: '企业定制服务',
              underlineFlag: false,
              navColFlg: '',
              idNum: '4-1',
              url: 'customizeHome/customizeService',
            },
            {
              name: '私人定制服务',
              underlineFlag: false,
              navColFlg: '',
              idNum: '4-2',
              url: 'customizeHome/privateService',
            },
          ],
        },
        {
          name: '软件产品',
          underlineFlag: false,
          navColFlg: '',
          idNum: '5',
          url: 'systemProduct',
          children: [
            {
              name: '京数应用商店',
              underlineFlag: false,
              navColFlg: '',
              idNum: '5-1',
              url: 'systemProduct/vargoAppStore',
            },
            {
              name: 'VTIME行政办公',
              underlineFlag: false,
              navColFlg: '',
              idNum: '5-2',
              url: 'systemProduct',
            },
            {
              name: '密语',
              underlineFlag: false,
              navColFlg: '',
              idNum: '5-3',
              url: 'systemProduct',
            },
            {
              name: '密信',
              underlineFlag: false,
              navColFlg: '',
              idNum: '5-4',
              url: 'systemProduct',
            },
            {
              name: '安全相册',
              underlineFlag: false,
              navColFlg: '',
              idNum: '5-5',
              url: 'systemProduct',
            },
            {
              name: '平行线-资源管理',
              underlineFlag: false,
              navColFlg: '',
              idNum: '5-6',
              url: 'systemProduct',
            },
            {
              name: '安全对讲',
              underlineFlag: false,
              navColFlg: '',
              idNum: '5-7',
              url: 'systemProduct',
            },
            {
              name: '音视会议',
              underlineFlag: false,
              navColFlg: '',
              idNum: '5-8',
              url: 'systemProduct',
            },
            {
              name: '安全传输',
              underlineFlag: false,
              navColFlg: '',
              idNum: '5-9',
              url: 'systemProduct',
            },
            {
              name: '京数云',
              underlineFlag: false,
              navColFlg: '',
              idNum: '5-0',
              url: 'systemProduct',
            },
          ],
        },
        {
          name: '服务',
          underlineFlag: false,
          navColFlg: '',
          idNum: '6',
          url: 'serviceHome',
          children: [
            {
              name: '售后服务',
              underlineFlag: false,
              navColFlg: '',
              idNum: '6-1',
              url: 'serviceHome/afterSalesService',
            },
            {
              name: '驱动下载',
              underlineFlag: false,
              navColFlg: '',
              idNum: '6-2',
              url: 'serviceHome',
            },
          ],
        },
        {
          name: '关于我们',
          underlineFlag: false,
          navColFlg: '',
          idNum: '7',
          url: 'aboutUs',
          children: [
            {
              name: '公司介绍',
              underlineFlag: false,
              navColFlg: '',
              idNum: '7-1',
              url: 'aboutUs/companyIntro',
            },
            {
              name: '团队介绍',
              underlineFlag: false,
              navColFlg: '',
              idNum: '7-2',
              url: 'aboutUs',
            },
            {
              name: '企业架构介绍',
              underlineFlag: false,
              navColFlg: '',
              idNum: '7-3',
              url: 'aboutUs',
            },
          ],
        },
        {
          name: '人才计划',
          underlineFlag: false,
          navColFlg: '',
          idNum: '8',
          url: 'talentsScheme',
        },
        {
          name: '硬件产品',
          underlineFlag: false,
          navColFlg: '',
          idNum: '11',
          url: 'InquiryForm',
          children: [
            {
              name: '京数卓越IV安全手机',
              underlineFlag: false,
              navColFlg: '',
              idNum: '11-1',
              url: 'InquiryForm',
            },
            {
              name: '24寸一体机',
              underlineFlag: false,
              navColFlg: '',
              idNum: '11-2',
              url: 'InquiryForm',
            },
            {
              name: '34寸一体机',
              underlineFlag: false,
              navColFlg: '',
              idNum: '11-3',
              url: 'InquiryForm',
            },
            {
              name: '配件产品',
              underlineFlag: false,
              navColFlg: '',
              idNum: '11-4',
              url: 'InquiryForm',
            },
          ],
        },
        {
          name: '企业福利',
          underlineFlag: false,
          navColFlg: '',
          idNum: '9',
          url: 'talentsSchemejl',
          children: [
            {
              name: '项目奖励',
              underlineFlag: false,
              navColFlg: '',
              idNum: '9-1',
              url: 'aboutUs',
            },
            {
              name: '平台奖励',
              underlineFlag: false,
              navColFlg: '',
              idNum: '9-2',
              url: 'aboutUs',
            },
          ],
        },
      ],
      botInfo: {},
      shopNavFlg: '',

      barNum: 0,
      contFlg: '0',
      switchNum: '0',
      shadeFlg: false,
      clssHei: '',
      shopFlg: false,
      homeFlg: true,
      servicFlg: false,
      governFlg: false,
      customizeFlg: false,
      softwareFlg: false,
      serveAllFlg: false,
      aboutUsFlg: false,
      talentFlg: false,
      awardFlg: false,
      submenuSum: '',
      enterp_somFlg: '',
      tapHeight: '',
      tempName: '',
    };
  },
  computed: {},
  watch: {},
  activated() {},
  updated() {
    let urlName;
    if (this.$route.name) {
      urlName = this.$route.name.split('/');
    }
    // console.log(urlName, this.tempName, "水电费", this.$store.state.tapList);
    this.$store.state.tapList.forEach((element, elementindex) => {
      if (urlName && urlName.indexOf(element?.url) != -1) {
        element.underlineFlag = true;
        if (element.children && element.children.length > 0) {
          element.children.forEach((children, childrenindex) => {
            if (this.tempName) {
              //点击菜单
              if (
                urlName[0] + '/' + urlName[1] == children?.url &&
                this.tempName == children?.name
              ) {
                children.underlineFlag = true;
                // console.log(children.name,"看看书1",children?.url);
              } else if (urlName[0] + '/' + urlName[1] != children?.url) {
                children.underlineFlag = false;
                // console.log(children.name,"看看书2");
              }
            } else {
              //刷新页面
              if (urlName[0] + '/' + urlName[1] == children?.url) {
                children.underlineFlag = true;
                // console.log(children.name,"看看书1",children?.url);
              } else if (urlName[0] + '/' + urlName[1] != children?.url) {
                children.underlineFlag = false;
                // console.log(children.name,"看看书2");
              }
            }

            if (urlName[0] + '/' + urlName[1] != children?.url) {
              children.underlineFlag = false;
            }

            if (children.children && children.children.length > 0) {
              children.children.forEach((children, childrenindex) => {
                if (
                  urlName[0] + '/' + urlName[1] + '/' + urlName[2] ==
                  children?.url
                ) {
                  children.underlineFlag = true;
                  // console.log(children.name,"看看书3");
                  this.$store.state.enterp_somFlg = children.idNum;
                } else {
                  children.underlineFlag = false;
                  // console.log(children.name,"看看书4");
                }
              });
            }
          });
        }
      } else {
        element.underlineFlag = false;
      }
    });
    // console.log("首页",this.$store.state.tapList);
  },
  created() {
    // console.log("首页", this.$route);
  },
  mounted() {
    homeBottom().then((res) => {
      if (res.data) {
        this.botInfo = res.data.data;
      }
      // console.log(res);
    });
    treeselect().then((res) => {
      // this.$store.state.treeList = res.data.data;
      // console.log(res.data.data, "测试类目数据", this.$store.state.tapList);
      this.$store.state.tapList.forEach((item, index) => {
        if (index != 0) {
          if (this.$store.state.treeList[index - 1].idNum == item.idNum) {
            item.name = this.$store.state.treeList[index - 1].label;
            if (!item.children) {
              item.children = this.$store.state.treeList[index - 1].children;
            }
          }
          if (item.children && item.children.length > 0) {
            item.children.forEach((item1, index1) => {
              if (
                this.$store.state.treeList[index - 1].children[index1].idNum ==
                item1.idNum
              ) {
                item1.name =
                  this.$store.state.treeList[index - 1].children[index1].label;
              }
              if (item1.children && item1.children.length > 0) {
                item1.children.forEach((item2, index2) => {
                  if (
                    this.$store.state.treeList[index - 1].children[index1]
                      .children[index2].idNum == item2.idNum
                  ) {
                    item2.name =
                      this.$store.state.treeList[index - 1].children[
                        index1
                      ].children[index2].label;
                  }
                });
              }
            });
          }
        }
      });
    });

    // console.log("首页测试", this.$store.state.tapList);
    // console.log("首页",this.$route.name);
    window.document
      .querySelector('.overlay')
      .addEventListener('scroll', this.handleScroll);
    // let redirectUri = this.getQueryString("redirectUri");
    // console.log(redirectUri, "传参");
    if (this.getQueryString('code')) {
      this.getVarGoToken(this.getQueryString('code'));
      localStorage.setItem(
        'redirectUri',
        JSON.stringify(this.getQueryString('redirectUri'))
      );
    }
  },
  methods: {
    routerRefresh() {
      this.routerAlive = false;
      this.$nextTick(() => {
        this.routerAlive = true;
      });
    },
    goBtnService(res) {
      console.log(res,"测试问题");
      this.routerRefresh();
      this.$router.push({
        // name: "detailTempIndex/templateDetail",
        name: res.routingPath,
        params: { id: res.id },
        // replace: true,
      });
    },
    blurSelectVal(e) {
      console.log(e);
      this.inputSelectVal = e;
    },
    inputSeleShow() {
      this.selectInputFlg = true;
    },
    // 测试跳转通用详情页
    goTempDetails() {
      window.location.href='https://shop.jingshucloud.com'
      // window.open('https://shop.jingshucloud.com')
    },
    goSearchIndex() {
      this.$router.push({
        // name: "detailTempIndex/templateDetail",
        name: 'globalSearch',
        params: { info: this.inputSelectVal },
      });
      // if (this.inputSelectVal) {
      //   localStorage.setItem("searchVal",this.inputSelectVal)
      // }
      // console.log(localStorage.getItem("searchVal"));
    },
    getQueryString(name) {
      let params = new URLSearchParams(location.search.replace(/\?/gi, ''));
      let data = {};
      for (let index of params) {
        data[index[0]] = index[1] || '';
      }
      // console.log(data, "传参看看data");
      return data[name];
    },
    getVarGoToken(row) {
      let data = {
        code: row,
      };
      console.log(
        row,
        JSON.parse(localStorage.getItem('redirectUri')),
        '水岸东方'
      );
      axios.post(JSON.parse(localStorage.getItem('redirectUri')), data).then(
        (response) => {
          console.log('请求成功了', response.data);
        },
        (error) => {
          console.log('请求失败了', error.message);
        }
      );
      // getVarGoToken(data).then((res) => {
      //   console.log(res,"res获取token");
      //   if (res.data.code == 200) {
      //     console.log(res.data,"获取token");
      //   }
      // });
    },

    tapClic(item, index) {
      let id = '';
      this.$store.state.enterp_somFlg = item.idNum;
      if (item.idNum != 99) {
        id = this.getID(item.name, this.$store.state.treeList).id;
        this.shopNavFlg = item.idNum;
      }
      this.$router.push({
        name: item.url,
        params: { id: id },
      });
      this.$store.state.tapList.forEach((element, elementindex) => {
        if (elementindex == index) {
          element.navColFlg = element.idNum;
          element.underlineFlag = true;
        } else {
          element.navColFlg = '';
          element.underlineFlag = false;
        }
        if (element.children && element.children.length > 0) {
          element.children.forEach((children, childrenindex) => {
            children.underlineFlag = false;
            if (children.children && children.children.length > 0) {
              children.children.forEach((children, childrenindex) => {
                children.underlineFlag = false;
              });
            }
          });
        }
      });
    },
    tapMous(row, leng) {
      // console.log(row, leng);
      // this.$store.state.enterp_somFlg = row;
      // || row == 4 || row == 7 || row == 5
      if (row == 99) {
        this.barNum = 0;
        this.shopNavFlg = 0;
        this.tapHeight = 0;
      } else {
        this.barNum = parseInt(row);
        this.shopNavFlg = row;
      }
      if (row == 2) {
        this.$store.state.enterp_somFlg = '2-1';
        this.tapHeight = 360;
        return;
      }
      if (row == 5) {
        this.tapHeight = 180;
        this.$store.state.enterp_somFlg = '5-1';
        return;
      }
      // this.tapHeight = this.$refs.shoppingNav.length*40
      if (leng) {
        // if (leng.length < 5) {
        //   this.tapHeight = leng.length * 50 + 80;
        // } else {
        //   this.tapHeight = leng.length * 50 + 40;
        // }
        if (leng.length == 0) {
          return;
        }
        if (leng.length < 5) {
          this.tapHeight = leng.length * 50 + 30;
        } else {
          this.tapHeight = leng.length * 45 + 20;
        }

        // console.log(row, "测试", leng, leng.length * 50, this.tapHeight);
      }
    },
    // 回调函数
    getID(name, list) {
      let _this = this;
      for (let item of list || []) {
        if (item.label == name) return item;
        const sum = _this.getID(name, item.children);
        if (sum) return sum;
      }
    },

    tapSubmenuClic(item, index, host) {
      this.$store.state.enterp_somFlg = item.idNum;
      console.log(
        item,
        item.name,
        index,
        host,
        this.$store.state.treeList,
        '测试二级点击',
        this.getID(item.name, this.$store.state.treeList).id
      );
      this.tempName = item.name;
      let id = this.getID(item.name, this.$store.state.treeList).id;
      if (host === 1) {
        return
      }
      if (host == 3) {
        if (index + 1) {
          localStorage.setItem("customizeflgId", index + 1);
        }
        if (item.id) {
          localStorage.setItem("customizeId", item.id);
        }
        this.$router.push({
          name: item.routingPath,
          params: { flgId: index + 1, id: item.id },
        });
        this.routerRefresh();
      } else if (host == 5) {
        if (this.getID(item.name, this.$store.state.treeList).id == 36) {
          geMenuDetailsInfo(
            this.getID(item.name, this.$store.state.treeList).id
          ).then((res) => {
            console.log(res);
            if (res.data) {
              this.$router.push({
                name: item.routingPath,
                params: { txt: res.data.data },
              });
            }
          });
        } else {
          this.$router.push({
            name: item.routingPath,
            params: {},
          });
        }
      } else {
        this.$router.push({
          name: item.url,
          params: { id: id },
        });
      }

      this.$store.state.tapList.forEach((element, elementindex) => {
        if (elementindex == host) {
          element.underlineFlag = true;
          element.children.forEach((children, childrenindex) => {
            if (childrenindex == index) {
              children.underlineFlag = true;
              // console.log(children.name, "撒地方撒1");
            } else {
              children.underlineFlag = false;
            }
          });
        } else {
          element.underlineFlag = false;
          if (element.children) {
            element.children.forEach((children, childrenindex) => {
              children.underlineFlag = false;
              // console.log(children.name,children.underlineFlag, "撒地方撒");
            });
          }
        }
      });
      // console.log(this.$store.state.tapList, "撒旦法");
    },
    childrenClic(item, index, home, top) {
      console.log(
        item,
        index,
        home,
        top,
        this.getID(item.name, this.$store.state.treeList).id,
        '三层点击'
      );

      let id = this.getID(item.name, this.$store.state.treeList).id;

      if (top == 4) {
        if (item.routingPath == 'detailTempIndex/templateDetail') {
          // console.log(item, "传入");
          if (item) {
            localStorage.setItem('typeId', item.id);
            localStorage.setItem('type', item.tableName);
          }
          this.$router.push({
            name: item.routingPath,
            // params: { info: item },
          });
          this.routerRefresh();
        } else {
          this.$router.push({
            name: item.routingPath,
            params: {},
          });
        }
      } else {
        this.$router.push({
          name: item.url,
          params: { id: id },
        });
      }

      this.$store.state.tapList.forEach((element, elementindex) => {
        if (elementindex == top) {
          element.underlineFlag = true;
          element.children.forEach((children, childrenindex) => {
            if (childrenindex == home) {
              children.underlineFlag = true;
              children.children.forEach((children, childrenindex) => {
                if (childrenindex == index) {
                  children.underlineFlag = true;
                } else {
                  children.underlineFlag = false;
                }
              });
            } else {
              children.underlineFlag = false;
              if (element.children) {
                element.children.forEach((children, childrenindex) => {
                  children.underlineFlag = false;
                  // console.log(children.name,children.underlineFlag, "撒地方撒");
                });
              }
            }
          });
        } else {
          element.underlineFlag = false;
          if (element.children) {
            element.children.forEach((children, childrenindex) => {
              children.underlineFlag = false;
              // console.log(children.name,children.underlineFlag, "撒地方撒");
            });
          }
        }
      });
    },
    tapSubmenuMous(row) {
      // console.log("测试", row);
      this.$store.state.enterp_somFlg = row;
    },

    handleScroll() {
      console.log(window.scrollY, '表示当前滚动的位置3');
      this.switchNum = '0';
    },
    switchflg(row, skip) {
      this.switchNum = row;
      this.submenuSum = row;
      if (skip) {
        window.scrollTo(0, 0);
        this.contFlg = skip;
      }

      // console.log(this.switchNum, this.contFlg);
    },
    switchContent(row) {
      window.scrollTo(0, 0);
      this.submenuSum = row;
      if (row == 99) {
        this.homeFlg = true;
        this.shopFlg = false;
        this.servicFlg = false;
        this.governFlg = false;
        this.customizeFlg = false;
        this.softwareFlg = false;
        this.serveAllFlg = false;
        this.aboutUsFlg = false;
        this.talentFlg = false;
        this.awardFlg = false;
        this.barNum = 0;
        this.clssHei = 0;
        this.$router.push({
          name: '/',
          params: {},
        });
      }

      if (row == 2) {
        this.servicFlg = true;
        this.homeFlg = false;
        this.shopFlg = false;
        this.governFlg = false;
        this.customizeFlg = false;
        this.softwareFlg = false;
        this.serveAllFlg = false;
        this.aboutUsFlg = false;
        this.talentFlg = false;
        this.awardFlg = false;
        this.$router.push({
          name: 'enterpriseHome',
          params: { id: id },
        });

        // this.barNum = 2;
        // this.clssHei = 350;
      }
      if (row == '2-1') {
        this.servicFlg = true;
        this.homeFlg = false;
        this.shopFlg = false;
        this.governFlg = false;
        this.customizeFlg = false;
        this.softwareFlg = false;
        this.serveAllFlg = false;
        this.aboutUsFlg = false;
        this.talentFlg = false;
        this.awardFlg = false;
        console.log('经理');
        let url = 'enterpriseHome/enterpriseService';
        this.$router.push({
          name: url,
          params: {},
        });
      }
      if (row == 3) {
        this.governFlg = true;
        this.homeFlg = false;
        this.shopFlg = false;
        this.servicFlg = false;
        this.customizeFlg = false;
        this.softwareFlg = false;
        this.serveAllFlg = false;
        this.aboutUsFlg = false;
        this.talentFlg = false;
        this.awardFlg = false;
        this.barNum = 3;

        let url = 'goveHome';
        this.$router.push({
          name: url,
          params: {},
        });

        this.clssHei = 280;
      }
      if (row == 4) {
        this.customizeFlg = true;
        this.homeFlg = false;
        this.shopFlg = false;
        this.servicFlg = false;
        this.governFlg = false;
        this.softwareFlg = false;
        this.serveAllFlg = false;
        this.aboutUsFlg = false;
        this.talentFlg = false;
        this.awardFlg = false;
        this.barNum = 4;
        this.clssHei = 150;
      }
      if (row == 5) {
        this.softwareFlg = true;
        this.homeFlg = false;
        this.shopFlg = false;
        this.servicFlg = false;
        this.governFlg = false;
        this.customizeFlg = false;
        this.serveAllFlg = false;
        this.aboutUsFlg = false;
        this.talentFlg = false;
        this.awardFlg = false;
        this.barNum = 5;
        this.clssHei = 200;
      }
      if (row == 6) {
        this.serveAllFlg = true;
        this.softwareFlg = false;
        this.homeFlg = false;
        this.shopFlg = false;
        this.servicFlg = false;
        this.governFlg = false;
        this.customizeFlg = false;
        this.aboutUsFlg = false;
        this.talentFlg = false;
        this.awardFlg = false;
        this.barNum = 6;
        this.clssHei = 360;
      }
      if (row == 7) {
        this.serveAllFlg = false;
        this.softwareFlg = false;
        this.homeFlg = false;
        this.shopFlg = false;
        this.servicFlg = false;
        this.governFlg = false;
        this.customizeFlg = false;
        this.aboutUsFlg = true;
        this.talentFlg = false;
        this.awardFlg = false;
        this.barNum = 7;
        this.clssHei = 240;
      }
      if (row == 8) {
        this.serveAllFlg = false;
        this.softwareFlg = false;
        this.homeFlg = false;
        this.shopFlg = false;
        this.servicFlg = false;
        this.governFlg = false;
        this.customizeFlg = false;
        this.aboutUsFlg = false;
        this.talentFlg = true;
        this.awardFlg = false;
        this.barNum = 8;
        this.clssHei = 0;
      }
      if (row == 9) {
        this.serveAllFlg = false;
        this.softwareFlg = false;
        this.homeFlg = false;
        this.shopFlg = false;
        this.servicFlg = false;
        this.governFlg = false;
        this.customizeFlg = false;
        this.aboutUsFlg = false;
        this.talentFlg = false;
        this.awardFlg = true;
        this.barNum = 9;
        this.clssHei = 0;
      }

      this.switchNum = row;
      this.contFlg = row;

      // document.getElementById("scrollRef").scrollIntoView({ behavior: "smooth" });
    },

    tologin() {
      // this.$router.push({
      //   name: "login",/myHome
      //   params: {},
      // });
      // http://47.103.10.147:9527/myHome
      let homeUrl = 'http://192.168.3.148:8081//myHome';
      getInfo().then((res) => {
        location.href =
          'http://47.103.10.147:9529?clientId=' +
          res.data.data.clientId +
          '&homeUrl=' +
          homeUrl;
      });
    },
    tobikeReg() {
      // this.$router.push({
      //   name: "bikeReg",
      //   params: { data: true },
      // });http://47.103.10.147:9529/
      // location.href =
      //   "http://47.103.10.147:9529/jingshuReg?openid=" + "京数官网";
      let homeUrl = 'http://192.168.40.170:8081/myHome';
      getInfo().then((res) => {
        location.href =
          'http://47.103.10.147:9529/jingshuReg?clientId=' +
          res.data.data.clientId +
          '&homeUrl=' +
          homeUrl;
      });
    },

    switchMenu() {
      // this.$emit("switchMenu", 1);
      this.switchNum = 1;
      // console.log("点击了switchMenu", this.switchNum);
    },
    cliShop() {
      this.shopFlg = true;
      this.homeFlg = false;
      this.servicFlg = false;
      this.governFlg = false;
      this.barNum = 1;
      this.clssHei = 230;
      this.contFlg = 1;
    },
    mousShop() {
      if (!this.shopFlg) {
        this.barNum = 1;
        this.clssHei = 280;
      }
    },
    mousEntServic(row) {
      // if (this.servicFlg) {
      this.$store.state.enterp_somFlg = row;
      this.barNum = row;
      // if (row == "1") {
      //   if (!this.shopFlg) {
      //     this.barNum = 1;
      //     this.clssHei = 280;
      //   }
      //   if (row == "2") {

      //     this.barNum = 2;
      //     this.clssHei = 400;
      //   }
      // }
      // }
    },
    enterp_som(row) {
      this.$store.state.enterp_somFlg = row;
    },
    governServic() {
      // if (this.governFlg) {
      this.barNum = 3;
      this.clssHei = 280;
      // }
    },
    customize() {
      // if (this.customizeFlg) {
      this.barNum = 4;
      this.clssHei = 150;
      // }
    },
    software() {
      // if (this.softwareFlg) {
      this.barNum = 5;
      this.clssHei = 200;
      // }
    },
    serveAll() {
      // if (this.serveAllFlg) {
      this.barNum = 6;
      this.clssHei = 360;
      // }
    },
    aboutUs() {
      // if (this.aboutUsFlg) {
      this.barNum = 7;
      this.clssHei = 240;
      // }
    },
    barNumZero() {
      this.barNum = 8;
      this.clssHei = 0;
    },
    toPage(url) {
      location.href = url;
    },
  },
};
</script>
<style lang="less" scoped>
.lefsty {
  left: 140px !important;
  height: 380px !important;
}
.lefstyCot {
  left: 190px !important;
  // border-radius: 6px;
  // background: rgba(255, 255, 255, 0.1);
  // padding: 0 20px;
}
.lefstyCotTop {
  // top: 10px !important;
  left: 470px !important;
}
.lefstyEsc {
  left: 170px !important;
  // height: 44px !important;
}
.lefstyEscTop {
  // top: 10px !important;
  left: 450px !important;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box; // 使得盒子的宽高不会超出设置的宽高
}
.topSelect {
  display: flex;
  align-items: center;
  /deep/ .el-input__inner {
    background-color: transparent;
    color: #fff;
  }
}

/deep/ .el-input__suffix-inner {
  .el-icon-search {
    font-size: 24px !important;
    color: #fff;
    opacity: 0.8;
    cursor: pointer;
  }
}
/deep/ .el-input-group__append {
  background-color: transparent;
  border: none;
}
/deep/ .el-input__inner:focus {
  border-color: #048799;
}
.inputSelect {
  width: 300px;
  margin-right: 20px;
}
.selectBtn {
  /deep/ .el-icon-search {
    font-size: 24px !important;
    color: #fff;
    opacity: 0.8;
  }
}

.bacFilter {
  -webkit-backdrop-filter: blur(11px);
}

// body {
//   margin: 8px !important;
// }
// #scrollRef{
//  background:  #003365;
// }
#scrollRef::-webkit-scrollbar {
  display: none;
}

.beian {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.el-backtop {
  width: 60px !important;
  height: 60px !important;
}

.backtop {
  height: 100%;
  width: 100%;
  background-color: #f2f5f6;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  text-align: center;
  line-height: 60px;
  color: #1989fa;
  z-index: 9999;
  border-radius: 50%;
}

.homeLogin {
  background: #000;
  color: #fff;
  height: 27px;
  width: 100%;
  text-align: right;
  position: fixed;
  z-index: 9999;
}

.homeCont {
  display: flex;
  justify-content: end;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0px auto;
  padding-top: 3px;
  font-size: 14px;
}

.topLoginCont {
  width: 110px;
  display: flex;
  justify-content: space-between;
}

.topLoginCont div:nth-child(1) {
  margin-right: 16px;
  cursor: pointer;
}

.topLoginCont div:nth-child(3) {
  margin-left: 16px;
  cursor: pointer;
}

.barCont {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0px auto;
}

.narbarCont {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 13px;
  // padding: 13px 12% 0 12%;
  // width: 80%;
  width: 100%;
  /*  小屏适配 */
  justify-content: space-between;
  width: 100%;
  // margin: 0 15px;
  // padding-top: 0px;
}

.shadeDiv {
  position: absolute;
  top: 79px;
  background-color: rgba(220, 218, 218, 0.7);
  // background: rgba(0,51,101,0.7);
  z-index: 7777;
  width: 99vw;
  height: 89vh;
}

// .overlay::-webkit-scrollbar {
//   display: none;
// }
.shadeCont {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgb(0 0 0 / 50%);
  z-index: 97;
}

.overlay {
  // position: fixed;
  // top: 0;
  // left: 0;
  // height: 89vh;
  // overflow-y: scroll;
  // width: 100%;
  // height: 100%;
  // background-color: rgba(203, 186, 186, 0.7); // 设置遮罩层背景颜色
  // z-index: 999; // 设置遮罩层层级，确保它在其他元素上方
}

.botLogo {
  width: 16%;
  // margin-top: 20px;
}

.botLogo img {
  width: 100%;
  margin-bottom: 36px;
}

.botTxt {
  // width: 220px;
}

.botTxt img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
  margin-bottom: 0px;
}

.botTitle {
  font-weight: bold;
  font-size: 16px;
}

.container_bottom {
  background: #f5f5f6;
  // background: linear-gradient(360deg, #003365 0%, #048799 100%);
  // width: 99vw;
  // height: 530px;
  // padding-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  margin-top: 100px;

  .container_bottom_Cont {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1200px;
    margin: 0px auto;
  }

  // 服务内容
  .serve {
    // padding: 0 6.25%;
    width: 100%;
    height: 430px;

    .serve_warpper {
      animation: companyBotTop 1.5s ease-out;
      // opacity: 0;
      padding-top: 70px;
      height: 100%;
      display: flex;
      justify-content: space-between;
      font-size: 15px;
      line-height: 33px;

      // .serve-item h4{
      //   color: #fff;
      // }
      .serve-item {
        // color: #fff;
        a {
          color: #000;
          text-decoration: none;
          cursor: pointer;

          &:hover {
            color: #048799;
          }
        }
      }
    }
  }

  .marleft {
    margin-left: 42px;
    // margin-left: 16px;
    /*  小屏适配 */
    margin-left: 0px;
  }
  .botBtnTxt:hover {
    color: #048799;
    cursor: pointer;
  }
  .tellBot {
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 14px;
  }

  .timeBot {
    display: flex;
    justify-content: left;
    align-items: center;
    font-size: 14px;
  }

  // 版权号
  .copyright {
    width: 100%;
    height: 70px;
    line-height: 70px;
    text-align: center;
    font-size: 15px;
    font-weight: 400;
    white-space: nowrap;
    color: #000;
    border: 1px solid #e2e2e2;
    // background: #003365;
  }
}
</style>
<style src="@/assets/css/index.css"></style>
<style lang="scss" scoped>
@import '@/assets/variables.scss';
@media (max-width: $ipad-max-size) {
  .pc-hidden {
    display: none !important;
  }
}
</style>
